<template>
  <div id="demo"></div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  data() {
    return {
      imgUrl: '',
      alt: '',
      pdfh5: null
    }
  },
  mounted() {
    let query = this.$route.query;
    if (query.imgUrl) {
      this.imgUrl = query.imgUrl
      this.pdfh5 = new Pdfh5("#demo", {
        pdfurl: this.imgUrl
      });
    }
    if (query.alt) {
      this.alt = query.alt
    }

  },
  beforeRouteEnter(to, from, next) { // 进入组件前判断，增加client，隐藏头部
    let query = to.query
    if (!query.client) {
      query.client = 1
      next({
        path: to.path,
        query: query
      })
    } else {
      next()
    }

  }
}
</script>

<style lang='scss'>

</style>